import { Badge, BADGE_STATUS } from "@/ui";

type ProfileMessagesStatusBadgeProps = {
  hasMessagesPendingToBeReadByAdmins: boolean | null;
};

export const ProfileMessagesStatusBadge = ({
  hasMessagesPendingToBeReadByAdmins,
}: ProfileMessagesStatusBadgeProps) => {
  if (hasMessagesPendingToBeReadByAdmins === null) {
    return null;
  }

  const badgeStatus = hasMessagesPendingToBeReadByAdmins
    ? BADGE_STATUS.ERROR
    : BADGE_STATUS.SUCCESS;

  return (
    <Badge className="capitalize" status={badgeStatus}>
      {hasMessagesPendingToBeReadByAdmins ? "Unread" : "Read"}
    </Badge>
  );
};
